import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="chat"
export default class extends Controller {
  static targets = ["message"]
  static values = {
    uid: Number
  }

  messageTargetConnected(message) {
    const messageUID = Number(message.dataset.uid);
    if (messageUID == this.uidValue) {
      message.classList.add("me");
    }

    const event = new CustomEvent("chat:new-message", { bubbles: true });
    this.element.dispatchEvent(event);
  }
}
